import React, { useEffect } from 'react'
import { EmptyNeedApproval, classes } from '.'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { IDocument } from 'types'
import { ListFile } from 'components/files/File'
import { RecentDocuments } from 'assets/svgIconComponents'
import SkeletonListFile from 'components/files/File/SkeletonListFile'
import { useUser } from 'queries/user/useUser'
import { useApprovalDocuments } from 'queries/documents/useApprovalDocuments'

interface IProps {
  documents: IDocument[] | undefined
}

const DocumentsList: React.FC<IProps> = ({ documents }) => {
  const { push } = useHistory()
  const user = useUser()!!

  const previewDocument = (document: IDocument) => {
    if (user.version === 'v3') {
      push(`/document/${document.templateId}/${document.id}/preview`)
    } else {
      push(`/${document.type === 'pdf' ? 'pdf' : 'document'}/${document.id}`)
    }
  }

  if (documents && documents.length === 0) {
    return <EmptyNeedApproval />
  } else {
    return (
      <div className={classes.list}>
        {documents?.slice(0, 4).map(document => {
          return (
            <ListFile
              key={document.id}
              id={document.id}
              title={document.name}
              type={document.type}
              edited={document.edited}
              onClick={() => previewDocument(document)}
            />
          )
        })}
      </div>
    )
  }
}

const SkeletonList: React.FC = () => {
  return (
    <div className={classes.list} data-skeleton={true}>
      <SkeletonListFile />
      <SkeletonListFile />
      <SkeletonListFile />
      <SkeletonListFile />
    </div>
  )
}

const NeedApprovalPanel: React.FC = () => {
  const { push } = useHistory()
  const { t } = useTranslation()

  const { refetch, data: documentFiles, isLoading, isStale } = useApprovalDocuments({ enabled: true })

  useEffect(() => {
    if (isStale) refetch()
  }, [refetch, isStale])

  return (
    <div className={classes.wrapper}>
      <div className={classes.title.wrapper}>
        <span className={classes.title.textAndIcon}>
          <RecentDocuments />
          {t('need_approval')}
        </span>
        <span onClick={() => push(`documents`)} className={classes.title.showAll}>
          {t('show_all')} &gt;
        </span>
      </div>
      {!isLoading ? <DocumentsList documents={documentFiles} /> : <SkeletonList />}
    </div>
  )
}

export default NeedApprovalPanel
